import React, { useEffect, useState } from "react";
import Box from "../../../setupPage/SharedComponents/Box";
import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
import { crmGetDashboard } from "../../../../api/crmApi";
import { Field, ROUTES, SelectInput } from "./crmShared";

const CrmDashboard = () => {
  const [data, setData] = useState(null);
  const [month, setMonth] = useState("");
  const [route, setRoute] = useState("");
  const [status, setStatus] = useState("");

  const load = async () => {
    const row = await crmGetDashboard({ month, route, status });
    setData(row);
  };

  useEffect(() => {
    load().catch(() => setData(null));
  }, [month, route, status]);

  const sales = data?.totalSales ?? data?.TotalSales ?? 0;
  const bookings = data?.totalBookings ?? data?.TotalBookings ?? 0;
  const months = data?.salesByMonth || data?.SalesByMonth || [];
  const routes = data?.shipmentsByRoute || data?.ShipmentsByRoute || [];
  const stages = data?.queryStages || data?.QueryStages || [];
  const maxMonth = Math.max(1, ...months.map((m) => Number(m.totalSales || m.TotalSales || 0)));
  const maxRoute = Math.max(1, ...routes.map((m) => Number(m.bookingCount || m.BookingCount || 0)));

  return (
    <Box top>
      <SetupTittle text="CRM Dashboard" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-5">
        <Field label="Month">
          <TextLike value={month} onChange={setMonth} placeholder="May" />
        </Field>
        <Field label="Route">
          <SelectInput value={route} onChange={setRoute} options={ROUTES} />
        </Field>
        <Field label="Status">
          <TextLike value={status} onChange={setStatus} placeholder="Delivered / Paid" />
        </Field>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="rounded-2xl bg-sky-100 p-4">
          <p className="text-sm text-stone-600">Total Sales</p>
          <p className="text-3xl font-bold">£{Number(sales).toLocaleString()}</p>
        </div>
        <div className="rounded-2xl bg-yellow-200 p-4">
          <p className="text-sm text-stone-600">Total Bookings</p>
          <p className="text-3xl font-bold">{bookings}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-stone-200 bg-white p-4">
          <p className="font-semibold mb-3">Sales by month</p>
          {months.map((m) => {
            const name = m.monthName || m.MonthName;
            const amt = Number(m.totalSales || m.TotalSales || 0);
            return (
              <div key={name} className="mb-2">
                <div className="flex justify-between text-sm">
                  <span>{name}</span>
                  <span>£{amt.toLocaleString()}</span>
                </div>
                <div className="h-3 bg-stone-100 rounded-full">
                  <div className="h-3 bg-blue-600 rounded-full" style={{ width: `${(amt / maxMonth) * 100}%` }} />
                </div>
              </div>
            );
          })}
        </div>
        <div className="rounded-2xl border border-stone-200 bg-white p-4">
          <p className="font-semibold mb-3">Shipments by route</p>
          {routes.map((m) => {
            const name = m.route || m.Route;
            const cnt = Number(m.bookingCount || m.BookingCount || 0);
            return (
              <div key={name} className="mb-2">
                <div className="flex justify-between text-sm">
                  <span>{name}</span>
                  <span>{cnt}</span>
                </div>
                <div className="h-3 bg-stone-100 rounded-full">
                  <div className="h-3 bg-orange-500 rounded-full" style={{ width: `${(cnt / maxRoute) * 100}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-6 flex flex-wrap gap-2">
        {stages.map((s) => (
          <span key={s.stage || s.Stage} className="rounded-full bg-stone-100 px-3 py-1 text-sm">
            {s.stage || s.Stage}: {s.cnt || s.Cnt}
          </span>
        ))}
      </div>
    </Box>
  );
};

const TextLike = ({ value, onChange, placeholder }) => (
  <input
    value={value}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
    className="w-full border border-stone-300 pl-3 h-10 outline-none rounded-xl bg-stone-50"
  />
);

export default CrmDashboard;
